// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2ZxIN","log":"ModalInventoryLogs_log__3OKrS","date":"ModalInventoryLogs_date__3RO46","userName":"ModalInventoryLogs_userName__1ZrMc"};